import React, { Component } from 'react'
import './calendaritem.scss'
class CalendarItem extends Component {

  render () {
    const { item } = this.props
    const style = {
      left: `${item.FromPercent}%`,
      right: `${100 - item.ToPercent}%`
    }
    return (
      <div className='calendar-item' style={style}>
        {this.props.children}
      </div>
    )
  }
}

// Test data
CalendarItem.defaultProps = {
  item: { // order
    FromPercent: 0,
    ToPercent: 35,
    Steps: [
      { FromPercent: 0, ToPercent: 5, Type: 1 },
      { FromPercent: 5, ToPercent: 78, Type: 2 },
      { FromPercent: 78, ToPercent: 95, Type: 3 },
      { FromPercent: 95, ToPercent: 100, Type: 1 }
    ]
  }
}

export default CalendarItem



// WEBPACK FOOTER //
// ./src/app/shared/components/Calendar/calendarItem/index.js